"use strict";

/** Типы финансовых операций */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingOperationEnum = void 0;
var BillingOperationEnum;
(function (BillingOperationEnum) {
  /** пополнение баланса */
  BillingOperationEnum[BillingOperationEnum["payment"] = 1] = "payment";
  /** резервирование оплаты урока */
  BillingOperationEnum[BillingOperationEnum["paid_meeting_deposit"] = 2] = "paid_meeting_deposit";
  /** возврат средств, резервированных для оплаты урока */
  BillingOperationEnum[BillingOperationEnum["paid_meeting_deposit_undo"] = 3] = "paid_meeting_deposit_undo";
  /** покупка урока */
  BillingOperationEnum[BillingOperationEnum["purchase_meeting"] = 4] = "purchase_meeting";
  /** возврат покупки урока */
  BillingOperationEnum[BillingOperationEnum["refund_meeting"] = 5] = "refund_meeting";
  /** покупка подписки на кредиты */
  BillingOperationEnum[BillingOperationEnum["purchase_credits_subscription"] = 7] = "purchase_credits_subscription";
  /** вывод средств */
  BillingOperationEnum[BillingOperationEnum["payout"] = 8] = "payout";
  /** сбор платформы */
  BillingOperationEnum[BillingOperationEnum["platform_fee"] = 9] = "platform_fee";
  /** сбор за процессинг платежей */
  BillingOperationEnum[BillingOperationEnum["payment_processing_fee"] = 10] = "payment_processing_fee";
  /** сбор за процессинг платежей */
  BillingOperationEnum[BillingOperationEnum["payout_processing_fee"] = 11] = "payout_processing_fee";
  /** тарификация проведения митинга (бесплатного, за кредиты) */
  BillingOperationEnum[BillingOperationEnum["meeting_providing"] = 12] = "meeting_providing";
  /** премиальное вознаграждение */
  BillingOperationEnum[BillingOperationEnum["bonus"] = 13] = "bonus";
  /** подарок */
  BillingOperationEnum[BillingOperationEnum["gift"] = 16] = "gift";
  /** штраф за митинг */
  BillingOperationEnum[BillingOperationEnum["public_meeting_fine"] = 18] = "public_meeting_fine";
  /** покупка доступа к платной группе */
  BillingOperationEnum[BillingOperationEnum["purchase_group_access"] = 19] = "purchase_group_access";
  /** возврат средств за доступ к платной группе */
  BillingOperationEnum[BillingOperationEnum["refund_group_access"] = 20] = "refund_group_access";
  /** покупка платного контента */
  BillingOperationEnum[BillingOperationEnum["purchase_content"] = 21] = "purchase_content";
  /** возврат средств за покупку платного контента */
  BillingOperationEnum[BillingOperationEnum["refund_content"] = 22] = "refund_content";
  /** купоны */
  BillingOperationEnum[BillingOperationEnum["coupon"] = 23] = "coupon";
  /** подарочные кредиты при подписке на кредиты */
  BillingOperationEnum[BillingOperationEnum["bonus_credits_subscription"] = 24] = "bonus_credits_subscription";
  /** отвязка карты */
  BillingOperationEnum[BillingOperationEnum["safe_card_detach"] = 26] = "safe_card_detach";
  /** Выплата по митингу */
  BillingOperationEnum[BillingOperationEnum["meeting_checkout"] = 28] = "meeting_checkout";
  /** Апгрейд лицензии на коллекцию */
  BillingOperationEnum[BillingOperationEnum["upgrade_collection"] = 30] = "upgrade_collection";
  /** Покупка кредитов */
  BillingOperationEnum[BillingOperationEnum["purchase_credits_v2"] = 33] = "purchase_credits_v2";
  /** Бонусы из поля BillingRewardActionEnum, начинаются от 100 */
  /**
   * @deprecated вознаграждение за проведение занятия (старое)
   * @see reward_meeting_succeed
   */
  BillingOperationEnum[BillingOperationEnum["reward_meeting"] = 14] = "reward_meeting";
  /**
   * @deprecated вознаграждение за контент (старое)
   * @see reward_content_succeed
   */
  BillingOperationEnum[BillingOperationEnum["reward_content"] = 15] = "reward_content";
  /**
   * @deprecated реферальное вознаграждение
   * @see reward_referral_purchase_succeed
   * @see reward_referral_subscription_succeed
   */
  BillingOperationEnum[BillingOperationEnum["reward_referral"] = 17] = "reward_referral";
  /** регистрация */
  BillingOperationEnum[BillingOperationEnum["reward_user_signed_up"] = 101] = "reward_user_signed_up";
  /** заполненный профиль пользователя */
  BillingOperationEnum[BillingOperationEnum["reward_user_profile_done"] = 102] = "reward_user_profile_done";
  /** верифицированный профиль преподавателя */
  BillingOperationEnum[BillingOperationEnum["reward_teacher_verified"] = 103] = "reward_teacher_verified";
  /** успешно проведённый урок */
  // TODO критерии успешности?
  BillingOperationEnum[BillingOperationEnum["reward_meeting_succeed"] = 104] = "reward_meeting_succeed";
  /** успешно опубликованный контент */
  // TODO критерии успешности?
  BillingOperationEnum[BillingOperationEnum["reward_content_succeed"] = 105] = "reward_content_succeed";
  /** реферальный пользователь совершил покупку */
  BillingOperationEnum[BillingOperationEnum["reward_referral_purchase_succeed"] = 106] = "reward_referral_purchase_succeed";
  /** реферальный пользователь совершил/продлил подписку */
  BillingOperationEnum[BillingOperationEnum["reward_referral_subscription_succeed"] = 107] = "reward_referral_subscription_succeed";
  /** Конвертация валют - списание */
  BillingOperationEnum[BillingOperationEnum["currency_conversion_withdraw"] = 300] = "currency_conversion_withdraw";
  /** Конвертация валют - зачисление */
  BillingOperationEnum[BillingOperationEnum["currency_conversion_top_up"] = 301] = "currency_conversion_top_up";
  /**
   * Заморозка кредитов на счёте
   *
   * @deprecated
   * @see credits_hold
   */
  BillingOperationEnum[BillingOperationEnum["hold_credits"] = 400] = "hold_credits";
  /** Заморозка кредитов на счёте */
  BillingOperationEnum[BillingOperationEnum["credits_hold"] = 400] = "credits_hold";
  /** Разморозка кредитов со счёта и перевод их обратно */
  BillingOperationEnum[BillingOperationEnum["credits_release"] = 401] = "credits_release";
  /** Списание кредитов со счёта */
  BillingOperationEnum[BillingOperationEnum["spend_credits"] = 402] = "spend_credits";
  /** Сгорание кредитов со счёта */
  BillingOperationEnum[BillingOperationEnum["burn_credits"] = 403] = "burn_credits";
  /** обновление подписки (любой) */
  BillingOperationEnum[BillingOperationEnum["account_subscription_updated"] = 500] = "account_subscription_updated";
  /** Коррекция от админа */
  BillingOperationEnum[BillingOperationEnum["admin_correction"] = 999] = "admin_correction";
})(BillingOperationEnum = exports.BillingOperationEnum || (exports.BillingOperationEnum = {}));
